import { Injectable } from '@angular/core';
import { CrudService } from '@appstrax/services/database';
import { AppNotification } from '@models';

@Injectable({ providedIn: 'root' })
export class AppNotificationService extends CrudService<AppNotification> {
  constructor() {
    super('app-notifications', AppNotification);
  }
}

